<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-nonrecommeded@3x.svg" alt="" />
    <span>Non-recommended products</span>
  </ng-container>

  <div body>
    <app-alert class="alert-wrapper">
      When you select any product from Table B, the organisation will:
      <ul>
        <li>
          Be solely responsible for ensuring that each product is suitable and
          appropriate for the organisation;
        </li>
        <li>Acknowledge that the purchase is at its own request;</li>
        <li>
          Not be able to rely on Section 27 of the FAA to file a civil claim
          against OCBC Bank
        </li>
      </ul>
    </app-alert>

    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <div
        class="box"
        *ngIf="
          this.model.recommendedProducts.length > 0 &&
          this.model.isAcceptRecommendedProducts
        "
      >
        <div class="table-title">Table A: Recommended products</div>
        <div class="blue-link fna-mb-30" (click)="showRecommendedProduct()">
          View detailed product descriptions
        </div>
        <div
          class="recommended-products"
          [class.show-all]="seeAllRecommendedProduct"
        >
          <div class="see-all" [class.see-less]="seeAllRecommendedProduct">
            <div
              class="blue-link"
              (click)="handleClickSeeAllRecommendedProduct()"
            >
              {{ seeAllRecommendedProduct ? 'See less' : 'See all' }}
            </div>
            <div class="blue-chevron"></div>
          </div>
          <div class="risk-section" *ngIf="recommendedLowRiskOption.length > 0">
            <div class="risk-title">Low risk</div>
            <div class="risk-content-wrapper">
              <div
                class="risk-content"
                *ngFor="let product of recommendedLowRiskOption"
              >
                <div class="product-title">{{ product.title }}</div>
                <div
                  *ngIf="product.shortDescription"
                  class="managed-content product-description"
                  [innerHTML]="product.shortDescription"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="recommendedModerateRiskOption.length > 0"
          >
            <div class="risk-title">Moderate risk</div>
            <div class="risk-content-wrapper">
              <div
                class="risk-content"
                *ngFor="let product of recommendedModerateRiskOption"
              >
                <div class="product-title">{{ product.title }}</div>
                <div
                  *ngIf="product.shortDescription"
                  class="managed-content product-description"
                  [innerHTML]="product.shortDescription"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="risk-section"
            *ngIf="recommendedHighRiskOption.length > 0"
          >
            <div class="risk-title">High risk products</div>
            <div class="risk-content-wrapper">
              <div
                class="risk-content"
                *ngFor="let product of recommendedHighRiskOption"
              >
                <div class="product-title">{{ product.title }}</div>
                <div
                  *ngIf="product.shortDescription"
                  class="managed-content product-description"
                  [innerHTML]="product.shortDescription"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="table-title">Table B: Non-recommended products</div>
        <div class="blue-link fna-mb-20" (click)="showNonRecommendedProduct()">
          View detailed product descriptions
        </div>

        <div
          *ngIf="model.shouldShowErrors && form.errors?.atLeastOneSelected"
          class="error fna-mb-10"
        >
          Please select at least one product
        </div>
        <ngb-accordion>
          <ngb-panel
            id="toggle-1"
            *ngIf="nonRecommendedLowRiskOption.length > 0"
          >
            <ng-template ngbPanelTitle>
              <div class="title">Low risk</div>
              <div class="chevron-icon"></div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div
                *ngFor="
                  let optionControl of nonRecommendedLowRiskProductsFormArray.controls;
                  index as productIndex
                "
                formArrayName="nonRecommendedLowRiskProducts"
                class="managed-content"
              >
                <app-checkbox
                  [label]="nonRecommendedLowRiskOption[productIndex].title"
                  [description]="
                    nonRecommendedLowRiskOption[productIndex].shortDescription
                  "
                  [name]="'' + productIndex"
                  formControlName="{{ productIndex }}"
                  [disabled]="nonRecommendedLowRiskOption[productIndex].hide"
                ></app-checkbox>
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel
            id="toggle-2"
            *ngIf="nonRecommendedModerateRiskOption.length > 0"
          >
            <ng-template ngbPanelTitle>
              <div class="title">Moderate risk</div>
              <div class="chevron-icon"></div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div
                *ngFor="
                  let optionControl of nonRecommendedModerateRiskProductsFormArray.controls;
                  index as productIndex
                "
                formArrayName="nonRecommendedModerateRiskProducts"
                class="managed-content"
              >
                <app-checkbox
                  [label]="nonRecommendedModerateRiskOption[productIndex].title"
                  [description]="
                    nonRecommendedModerateRiskOption[productIndex]
                      .shortDescription
                  "
                  [name]="'' + productIndex"
                  formControlName="{{ productIndex }}"
                  [disabled]="nonRecommendedModerateRiskOption[productIndex].hide"
                ></app-checkbox>
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel
            id="toggle-3"
            *ngIf="nonRecommendedHighRiskOption.length > 0"
          >
            <ng-template ngbPanelTitle>
              <div class="title">High risk</div>
              <div class="chevron-icon"></div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div
                *ngFor="
                  let optionControl of nonRecommendedHighRiskProductsFormArray.controls;
                  index as productIndex
                "
                formArrayName="nonRecommendedHighRiskProducts"
                class="managed-content"
              >
                <app-checkbox
                  [label]="nonRecommendedHighRiskOption[productIndex].title"
                  [description]="
                    nonRecommendedHighRiskOption[productIndex].shortDescription
                  "
                  [name]="'' + productIndex"
                  formControlName="{{ productIndex }}"
                  [disabled]="nonRecommendedHighRiskOption[productIndex].hide"
                  
                ></app-checkbox>
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel
            id="toggle-4"
            *ngIf="nonRecommendedOthersOption.length > 0"
          >
            <ng-template ngbPanelTitle>
              <div class="title">Others</div>
              <div class="chevron-icon"></div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div
                *ngFor="
                  let optionControl of nonRecommendedOtherProductsFormArray.controls;
                  index as productIndex
                "
                formArrayName="nonRecommendedOtherProducts"
                class="managed-content"
              >
                <app-checkbox
                  [label]="nonRecommendedOthersOption[productIndex].title"
                  [description]="
                    nonRecommendedOthersOption[productIndex].shortDescription
                  "
                  [name]="'' + productIndex"
                  formControlName="{{ productIndex }}"
                  [selectedContentTemplate]="
                    nonRecommendedOtherAdditionalContent
                  "
                ></app-checkbox>
                <ng-template #nonRecommendedOtherAdditionalContent>
                  {{ model.treasuryAdvisorName }} will contact you upon the
                  submission of the Financial Needs Analysis
                </ng-template>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>

      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button buttonType="submit"></app-next-button>
      </div>
    </form>

    <div *ngIf="globals.isDebug" class="mt56">
      <h3>Information for developers, please ignore</h3>
      <!--    <h4>Data</h4>-->
      <!--    <pre class="debug-log-mono">{{ model.data | json }}</pre>-->
      <h4>Model</h4>
      <h5>nonRecommendedProducts</h5>
      <pre class="debug-log-mono">{{
        model.nonRecommendedProductsOptions | json
      }}</pre>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>
